// src/constants.js

// sentiment codes:  2=strong bullish, 1=bullish, 0=neutral, -1=bearish, -2=strong bearish
export const SENTIMENT_COLORS = Object.freeze({
  "-100": "#E2E8F0", // N/A (slate-200)
  "2":    "#10B981", // strong bullish
  "1":    "#34D399", // bullish
  "0":    "#94A3B8", // neutral (slate-400)
  "-1":   "#F87171", // bearish
  "-2":   "#EF4444"  // strong bearish
});

export const SENTIMENT_LABELS = Object.freeze({
  "-100": "N/A",
  "2":    "Bullish - Strong",
  "1":    "Bullish",
  "0":    "Neutral",
  "-1":   "Bearish",
  "-2":   "Bearish - Strong"
});

// Optional: matching border tones if you need them
export const SENTIMENT_BORDERS = Object.freeze({
  "-100": "#CBD5E1",
  "2":    "#059669",
  "1":    "#10B981",
  "0":    "#64748B",
  "-1":   "#DC2626",
  "-2":   "#B91C1C"
});

// Helper: accept a code (number/string) OR a label like "bullish"/"bearish"
export function colorForSentiment(codeOrLabel, fallback = "#94A3B8") {
  if (codeOrLabel == null) return fallback;

  // If it's a number/string code
  const key = String(codeOrLabel);
  if (SENTIMENT_COLORS[key]) return SENTIMENT_COLORS[key];

  // If it's a label
  const v = String(codeOrLabel).toLowerCase();
  if (v.includes("strong") && v.includes("bull")) return SENTIMENT_COLORS["2"];
  if (v.includes("strong") && v.includes("bear")) return SENTIMENT_COLORS["-2"];
  if (v.includes("bull")) return SENTIMENT_COLORS["1"];
  if (v.includes("bear")) return SENTIMENT_COLORS["-1"];
  return SENTIMENT_COLORS["0"];
}
